import { defineMessages } from 'react-intl'

export default defineMessages({
  dateCreated: {
    id: 'SpaceNotificationSourcePage.DateCreated',
    defaultMessage: 'Date Created'
  },
  existingNotificationSources: {
    id: 'SpaceNotificationSourcePage.NotificationSources.Title',
    defaultMessage: 'Existing Notification Sources'
  },
  displayTitle: {
    id: 'SpaceNotificationSourcePage.DisplayTitle',
    defaultMessage: 'Display Title'
  },
  icon: {
    id: 'SpaceNotificationSourcePage.Icon',
    defaultMessage: 'Icon'
  },
  notificationSources: {
    id: 'SpaceNotificationSourcePage.Table.ItemType',
    defaultMessage: 'notification sources'
  }
})
